import React from 'react';
import { Video } from '../Components/Video';
import MainContent from '../Components/Global/MainContent';

const EmptyScreen = ({ optionData, eventData }) => {
  const showVideo = !eventData?.acf?.disable_video_background;
  return (
    <>
      {showVideo && <Video layer="bg" />}
      <MainContent></MainContent>
      {showVideo && <Video layer="fg" />}
    </>
  );
};

export default EmptyScreen;
